import Axios from 'axios'
import persistentData from '@/plugins/persistentData'
import moment from 'moment'

const InterceptorAPI = {
  validateVersionFront(versionApp, versionWeb) {
    if (window["cordova"] != undefined) {
      // Compare version APP
      if (!Number.isNaN(Number(versionApp)) && Number(process.env.VUE_APP_VERSION) < Number(versionApp) ) {
        window.mainApp.$store.dispatch('openModalUpdateVersionApp')
      }
    } else {
      // Compare version WEB
      const version_now = persistentData.getData('x-web-v', false)
      if (version_now == null) {
        persistentData.setData('x-web-v', versionWeb, false)
      } else if (version_now !== versionWeb) {
        persistentData.setData('x-web-v', versionWeb, false)
        window.location.reload()
      } 
    }
  },
  getHeaders() {
    const params = {
      "Content-Type": "application/json"
    }
    const token = persistentData.getData('token') 
    if (token) params.Authorization = `Bearer ${token}` 
    
    return params
  },
  async validateToken() {
    const self = this
    const expired = moment(persistentData.getData('tokenExpiration'))
    if (expired.diff(moment(), 'm') < 1) {
      await self.refreshToken()
    }
    return true
  },
  async refreshToken() {
    try {
      const response = await Axios.post(`${process.env.VUE_APP_API_URL_SECURITY}${process.env.VUE_APP_API_SECURITY}/refreshToken`, {'Value': persistentData.getData('token', false)})
      persistentData.setData("tokenExpiration", response.data.tokenExpiration)
      persistentData.setData("token", response.data.token)
      return response
    } catch (error) {
      persistentData.removeData('token')
      persistentData.removeData('tokenExpiration')
      persistentData.removeData('fullName')
      window.mainApp.$router.push(`/login`)
    }
  },
  async get(endpoint, timeout = 0) {
    const self = this
    try {
      await self.validateToken() 
      try {
        const response = await Axios.get(endpoint, { headers: self.getHeaders(), timeout })
        if(response.headers['x-app-v'] || response.headers['x-web-v']) self.validateVersionFront(response.headers['x-app-v'], response.headers['x-web-v'])
        return response
      } catch (errorResponse) {
        if (errorResponse.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.get(endpoint, { headers: self.getHeaders(), timeout })
              return response
            }
          } catch (errorToken) {
            if (errorToken.response == undefined) return;

            window.mainApp.$store.dispatch('addNotification', {
              value: errorToken.response.data,
              status: 'error',
              remove: true
            })
          }
        }
      }
    } catch(errorToken) {
      if (errorToken.response == undefined) return;

      window.mainApp.$store.dispatch('addNotification', {
        value: errorToken.response.data,
        status: 'error',
        remove: true
      })
    }
  },
  async post(endpoint, data) {
    const self = this
    try {
      await self.validateToken()
      try {
        const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
        return response
      } catch (error) {
        if (error.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
              return response
            }
          } catch (error) {
            window.mainApp.$store.dispatch('addNotification', {
              value: error.response.data,
              status: 'error',
              remove: true
            })
          }
        }
      }
    } catch (error) {
      window.mainApp.$store.dispatch('addNotification', {
        value: error.response.data,
        status: 'error',
        remove: true
      })
    }
  },
  async put(endpoint, data) {
    const self = this
    try {
      await self.validateToken()
      try {
        const response = await Axios.put(endpoint, data, { headers: self.getHeaders() })
        return response
      } catch (error) {
        if (error.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.put(endpoint, data, { headers: self.getHeaders() })
              return response
            }
          } catch (error) {
            window.mainApp.$store.dispatch('addNotification', {
              value: error.response.data,
              status: 'error',
              remove: true
            })
          }
        }
      }
    } catch (error) {
      window.mainApp.$store.dispatch('addNotification', {
        value: error.response.data,
        status: 'error',
        remove: true
      })
    }
  },
  async postWithoutToken(endpoint, data) {
    const self = this
    try {
      const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
      return response
    } catch (error) {
      window.mainApp.$store.dispatch('addNotification', {
        value: error.response.data == 'invalidUser' ? `${window.mainApp.$t('notifications.invalidUser')}` : error.response.data,
        status: 'error',
        remove: true
      })
    }
  },
  async getWithoutToken(endpoint) {
    const self = this
    try {
      const response = await Axios.get(endpoint, { headers: self.getHeaders() })
      return response
    } catch (error) {
      console.error(error)
    }
  }
}

export default InterceptorAPI